import { render, staticRenderFns } from "./ConfirmRemovingDocumentModalNew.vue?vue&type=template&id=1b5db050"
import script from "./ConfirmRemovingDocumentModalNew.vue?vue&type=script&lang=ts"
export * from "./ConfirmRemovingDocumentModalNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5db050')) {
      api.createRecord('1b5db050', component.options)
    } else {
      api.reload('1b5db050', component.options)
    }
    module.hot.accept("./ConfirmRemovingDocumentModalNew.vue?vue&type=template&id=1b5db050", function () {
      api.rerender('1b5db050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ConfirmRemovingDocumentModalNew.vue"
export default component.exports